/**
 * Centralized API endpoint constants.
 * All API paths used across the app are defined here.
 * Prevents typos and makes endpoint changes easy.
 */

// ─── Auth Endpoints (User) ──────────────────────────────────
export const AUTH_ENDPOINTS = {
  LOGIN_STATUS: '/auth/login-status',
  LOGIN: '/auth/login/traditional',
  REGISTER: '/auth/register',
  LOGOUT: '/auth/logout',
  GOOGLE_LOGIN: '/auth/login/google',
  REQUEST_PASSWORD_RESET: '/auth/request-password-reset',
  RESET_PASSWORD: '/auth/reset-password',
};

// ─── Auth Endpoints (Admin) ─────────────────────────────────
export const ADMIN_AUTH_ENDPOINTS = {
  LOGIN: '/admin/login',
  LOGOUT: '/admin/logout',
};

// ─── Admin Dashboard Endpoints ──────────────────────────────
export const DASHBOARD_ENDPOINTS = {
  STATS: '/admin/dashboard/stats',
  TICKETS_BREAKDOWN: '/admin/tickets/breakdown',
};

// ─── Admin Ticket Endpoints ─────────────────────────────────
export const ADMIN_TICKET_ENDPOINTS = {
  LIST: '/admin/tickets',
  UNASSIGNED: '/admin/tickets/unassigned',
  DETAIL: (id) => `/admin/tickets/${id}`,
  DELETE: (id) => `/admin/tickets/${id}`,
  UPDATE_STATUS: (id) => `/admin/tickets/${id}/status`,
  REPLY: (id) => `/admin/tickets/${id}/reply`,
  ASSIGN: '/admin/tickets/assign',
  COMMENTS: (id) => `/admin/tickets/${id}/comments`,
  JIRA_SYNC: (id) => `/admin/tickets/${id}/jira-sync`,
};

// ─── Admin Employee Endpoints ───────────────────────────────
export const EMPLOYEE_ENDPOINTS = {
  LIST: '/admin/employees',
  CREATE: '/admin/employees',
  UPDATE: (id) => `/admin/employees/${id}`,
  DELETE: (id) => `/admin/employees/${id}`,
};

// ─── Admin User Endpoints ───────────────────────────────────
export const ADMIN_USER_ENDPOINTS = {
  LIST: '/admin/users',
};

// ─── User Profile Endpoints ─────────────────────────────────
export const PROFILE_ENDPOINTS = {
  GET: '/profile',
  DELETE_SEARCH: (id) => `/delete-search/${id}`,
  CHANGE_PASSWORD: '/change-password',
  UPDATE_TIMEZONE: '/user/timezone',
};

// ─── Search History Results Endpoints ───────────────────────
export const SEARCH_HISTORY_ENDPOINTS = {
  RESULTS: (id) => `/search-history/${id}/results`,
  DOWNLOAD: (id, format) => `/search-history/${id}/download?format=${format}`,
};

// ─── User Scrape Endpoints ──────────────────────────────────
export const SCRAPE_ENDPOINTS = {
  SCRAPE: '/scrape',
};

// ─── User Ticket Endpoints ──────────────────────────────────
export const USER_TICKET_ENDPOINTS = {
  LIST: '/support/tickets',
  CREATE: '/support/create-ticket',
  DETAIL: (id) => `/support/ticket/${id}`,
  COMMENTS: (id) => `/support/ticket/${id}/comments`,
};

// ─── Chat Endpoints ─────
export const CHAT_ENDPOINTS = {
  SEND: '/chat',
};